import axios from 'axios'
import store from '../store/index.js'
import router from '../router/index.js'

const http = axios.create({
	timeout: 10000,
	withCredentials: true,
	headers: {
		'Access-Control-Allow-Origin': '*',
		'Content-Type': 'application/json; charset=utf-8'
	}
})
//判断环境提供baseURL，注意要与后台地址一致
let root = process.env.NODE_ENV === 'development'
	// 开发环境api接口
	?
	`http://192.168.18.43:8083/sso/manage`
	// `http://taxi.saas.api.test.yuntuzl.net:8888/sso/manage`
	// 生产环境api接口
	:
	`https://taxi.saas.api.yuntuzl.net/sso/manage`;
	// `http://taxi.saas.api.test.yuntuzl.net:8888/sso/manage`;
/**
 * 请求拦截
 */
http.interceptors.request.use(config => {
	config.headers['Authorization'] =  store.state.token || '' // 请求头带上token
	/* console.log("-------------addtoken-------------") */
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
http.interceptors.response.use(response => {

	/* console.log("-------------response interceptors-------------") */
	if (response.data && response.data.code === 12) { // 401, token失效
		/* clearLoginInfo() */
		store.commit('setToken', '');
		localStorage.removeItem("sso-key")
		router.push({
			path: '/loginform'
		}).catch(srr => {})

	}
	return response
}, error => {
	return Promise.reject(error)
})

const upload = axios.create({
	timeout: 30000,
	headers: {
		"Content-Type": "multipart/form-data"
	},
})


/**
 * 请求拦截
 */
upload.interceptors.request.use(config => {
	config.headers['Authorization'] = store.state.token || '' // 请求头带上token
	/* console.log("-------------addtoken-------------") */
	return config
}, error => {
	return Promise.reject(error)
})

/**
 * 响应拦截
 */
upload.interceptors.response.use(response => {
	/* console.log("-------------response interceptors-------------") */
	if (response.data && response.data.code === 12) { // 401, token失效
		/* clearLoginInfo() */
		localStorage.removeItem("sso-key")
		router.push({
			path: '/loginform'
		})
	}
	return response
}, error => {
	return Promise.reject(error)
})




function apiAxios(method, url, params,config) {
	let configAll = {
		method: method,
		url: url,
		data: method === 'POST' && params ? JSON.stringify(params) : null,
		baseURL: root,
	}
	configAll = Object.assign(configAll, config);
	return http(configAll)
}

function uploadAxios(url, formData) {
	return upload({
		method: 'POST',
		url: url,
		data: formData,
		baseURL: root,
	})
}

export default {
	get: function(url) {
		return apiAxios('GET', url)
	},
	post: function(url, params,config) {
		return apiAxios('POST', url, params,config)
	},
	upload: function(url, formData) {
		return uploadAxios(url, formData)
	}
}
